import { cellRenderParseData } from '../../../utils/functions';

const byReadyDataGrid = [
  {
    dataField: 'qcId',
    caption: 'СК (ГП)',
    dataType: 'string'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК (ГП)',
    cellRender: cellRenderParseData,
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во, теор.',
    dataType: 'number'
  },
  {
    dataField: 'quantityOff',
    caption: 'Кол-во, факт.',
    dataType: 'string'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderId',
    caption: 'Заказ ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Позиция ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'profileSize',
    caption: 'Профилеразмер',
    dataType: 'string'
  },
  {
    dataField: 'thickness',
    caption: 'Толщина',
    dataType: 'string'
  },
  {
    dataField: 'length',
    caption: 'Длина',
    dataType: 'number'
  },
  {
    dataField: 'mark',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'normativeDoc',
    caption: 'Нормативный документ',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default byReadyDataGrid;
